import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  tooltip: 'Customer did not receive Invoice',
})
